<template>
  <footer class="py-5 bg-dark">
    <div class="container">
      <p class="m-0 text-center text-white">Copyright &copy; Simplex 2018</p>
    </div>
    <!-- /.container -->
  </footer>
</template>

<script>
export default {
  name: 'MyBottom',
};
</script>

<style scoped>
  footer {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
</style>
